import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RosterService {
  private apiUrl = environment.baseUrl + '/wfm/roster';

  constructor(private http: HttpClient) { }

  getRoster(weekNumber: number, year: number, shopIds: number[] = []): Observable<any> {
    let url = `${this.apiUrl}/get?week_number=${weekNumber}&year=${year}`;
    if (shopIds && shopIds.length > 0) {
      url += `&shop_ids=${shopIds.join(',')}`;
    }
    return this.http.get(url);
  }

  saveRoster(rosterData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/save`, rosterData);
  }

  finalizeAttendance(data: { attendance_id: number, shop_id: number }): Observable<any> {
    return this.http.post(`${this.apiUrl}/finalize-attendance`, data);
  }

  undoFinalizeAttendance(data: { attendance_id: number, shop_id: number }): Observable<any> {
    return this.http.post(`${this.apiUrl}/undo-finalize-attendance`, data);
  }

  bulkFinalizeAttendance(data: { attendances: any[], is_finalized: number }): Observable<any> {
    return this.http.post(`${this.apiUrl}/bulk-finalize-attendance`, data);
  }

  getRosterList(requestData?: any): Observable<any> {
    if (requestData) {
      return this.http.post(`${this.apiUrl}/getList`, requestData);
    }
    return this.http.get(`${this.apiUrl}/getList`);
  }

  deleteRoster(id: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/delete`, { id });
  }

  cloneRoster(params: {
    target_week: number;
    target_year: number;
    source_week: number;
    source_year: number;
    clone_type: string;
    check_only?: boolean;
  }): Observable<any> {
    return this.http.post(`${this.apiUrl}/clone`, params);
  }

  confirmRoster(id: number, status: number = 1): Observable<any> {
    return this.http.post(`${this.apiUrl}/confirm`, { id, status });
  }

  getWeekDefs(): Observable<any> {
    return this.http.get(`${this.apiUrl}/getWeekDefs`);
  }

  exportRoster(weekNumber: number, year: number, shopIds: number[], exportType: number): Observable<Blob> {
    let url = `${this.apiUrl}/export?week_number=${weekNumber}&year=${year}&export_type=${exportType}`;
    if (shopIds && shopIds.length > 0) {
      url += `&shop_ids=${shopIds.join(',')}`;
    }
    return this.http.get(url, { responseType: 'blob' });
  }

  saveRosterScreenshot(data: { image: string, hdr_id?: number, dr_hdr_id?: number }): Observable<any> {
    return this.http.post(`${this.apiUrl}/save-screenshot`, data);
  }

  sendRosterEmail(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/send-email`, payload);
  }

  getEmployeeRoster(employeeId: number, weekNumber: number, year: number): Observable<any> {
    return this.http.get(environment.baseUrl + `/wfm/employee/roster`, {
      params: {
        employee_id: employeeId.toString(),
        roster_week: weekNumber.toString(),
        roster_year: year.toString()
      }
    });
  }
}
